export default __webpack_public_path__ + "static/media/ic_enhanced-list-view.ceb3167d.svg";